import * as Criteria from "./Criteria/index.js";
import * as Renters from "./Renters/index.js";
import * as VerifyIdentity from "./VerifyIdentity/index.js";
import { ImageSize } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ImageSize */
export { ImageSize };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AddListingStatusRequest */
export var AddListingStatusRequest;
(function (AddListingStatusRequest) {
    AddListingStatusRequest[AddListingStatusRequest["None"] = 0] = "None";
    AddListingStatusRequest[AddListingStatusRequest["Active"] = 1] = "Active";
    AddListingStatusRequest[AddListingStatusRequest["OffMarket"] = 3] = "OffMarket";
    AddListingStatusRequest[AddListingStatusRequest["Unpublished"] = 6] = "Unpublished";
    AddListingStatusRequest[AddListingStatusRequest["UserDeleted"] = 8] = "UserDeleted";
})(AddListingStatusRequest || (AddListingStatusRequest = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.SourceApplication */
export var SourceApplication;
(function (SourceApplication) {
    SourceApplication[SourceApplication["Unknown"] = 0] = "Unknown";
    SourceApplication[SourceApplication["Apple"] = 1] = "Apple";
    SourceApplication[SourceApplication["Android"] = 2] = "Android";
})(SourceApplication || (SourceApplication = {}));
import { CommuteTravelMode } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.CommuteTravelMode */
export { CommuteTravelMode };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ShapeType */
export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Unknown"] = 0] = "Unknown";
    ShapeType[ShapeType["PostalCode"] = 2] = "PostalCode";
    ShapeType[ShapeType["City"] = 3] = "City";
    ShapeType[ShapeType["Submarket"] = 5] = "Submarket";
    ShapeType[ShapeType["Street"] = 6] = "Street";
    ShapeType[ShapeType["ResearchMarket"] = 7] = "ResearchMarket";
    ShapeType[ShapeType["County"] = 10] = "County";
    ShapeType[ShapeType["Subdivision"] = 11] = "Subdivision";
    ShapeType[ShapeType["Country"] = 15] = "Country";
    ShapeType[ShapeType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    ShapeType[ShapeType["Region"] = 17] = "Region";
    ShapeType[ShapeType["CBSA"] = 18] = "CBSA";
    ShapeType[ShapeType["CSA"] = 19] = "CSA";
    ShapeType[ShapeType["DMA"] = 20] = "DMA";
    ShapeType[ShapeType["Cluster"] = 21] = "Cluster";
    ShapeType[ShapeType["School"] = 37] = "School";
})(ShapeType || (ShapeType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AttachmentType */
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["Unknown"] = 0] = "Unknown";
    AttachmentType[AttachmentType["Aerial"] = 1] = "Aerial";
    AttachmentType[AttachmentType["Financial"] = 2] = "Financial";
    AttachmentType[AttachmentType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    AttachmentType[AttachmentType["BuildingPhoto"] = 4] = "BuildingPhoto";
    AttachmentType[AttachmentType["VirtualTour"] = 5] = "VirtualTour";
    AttachmentType[AttachmentType["Lobby"] = 6] = "Lobby";
    AttachmentType[AttachmentType["Other"] = 7] = "Other";
    AttachmentType[AttachmentType["MarketingBrochure"] = 8] = "MarketingBrochure";
    AttachmentType[AttachmentType["PlatMap"] = 9] = "PlatMap";
    AttachmentType[AttachmentType["FloorPlan"] = 10] = "FloorPlan";
    AttachmentType[AttachmentType["SitePlan"] = 11] = "SitePlan";
    AttachmentType[AttachmentType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    AttachmentType[AttachmentType["Slate"] = 13] = "Slate";
    AttachmentType[AttachmentType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    AttachmentType[AttachmentType["Logo"] = 15] = "Logo";
    AttachmentType[AttachmentType["Map"] = 16] = "Map";
    AttachmentType[AttachmentType["SmallImage"] = 17] = "SmallImage";
    AttachmentType[AttachmentType["LargeImage"] = 18] = "LargeImage";
    AttachmentType[AttachmentType["TenantPhoto"] = 19] = "TenantPhoto";
    AttachmentType[AttachmentType["LeaseDocument"] = 20] = "LeaseDocument";
    AttachmentType[AttachmentType["PublicFiling"] = 21] = "PublicFiling";
    AttachmentType[AttachmentType["Deed"] = 22] = "Deed";
    AttachmentType[AttachmentType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    AttachmentType[AttachmentType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    AttachmentType[AttachmentType["RentAndLeaseAssignment"] = 25] = "RentAndLeaseAssignment";
    AttachmentType[AttachmentType["Loan"] = 26] = "Loan";
    AttachmentType[AttachmentType["Article"] = 27] = "Article";
    AttachmentType[AttachmentType["PressRelease"] = 28] = "PressRelease";
    AttachmentType[AttachmentType["SecuritiesExchangeCommissionFiling"] = 29] = "SecuritiesExchangeCommissionFiling";
    AttachmentType[AttachmentType["CompanyReport"] = 30] = "CompanyReport";
    AttachmentType[AttachmentType["MediaSource"] = 31] = "MediaSource";
    AttachmentType[AttachmentType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    AttachmentType[AttachmentType["InteriorPhoto"] = 33] = "InteriorPhoto";
    AttachmentType[AttachmentType["GoadMap"] = 34] = "GoadMap";
    AttachmentType[AttachmentType["CommunityBrochure"] = 35] = "CommunityBrochure";
    AttachmentType[AttachmentType["PlacardLogo"] = 36] = "PlacardLogo";
    AttachmentType[AttachmentType["PropertyLogo"] = 37] = "PropertyLogo";
    AttachmentType[AttachmentType["ConstructionPhoto"] = 38] = "ConstructionPhoto";
    AttachmentType[AttachmentType["ReinforcingAdvertisement"] = 39] = "ReinforcingAdvertisement";
    AttachmentType[AttachmentType["ProVideo"] = 40] = "ProVideo";
    AttachmentType[AttachmentType["CityPhoto"] = 41] = "CityPhoto";
    AttachmentType[AttachmentType["NeighborhoodPhoto"] = 42] = "NeighborhoodPhoto";
    AttachmentType[AttachmentType["ThreeDimensionalScan"] = 43] = "ThreeDimensionalScan";
    AttachmentType[AttachmentType["ProVideoApartmentFinder"] = 44] = "ProVideoApartmentFinder";
    AttachmentType[AttachmentType["ProVideoApartamentos"] = 46] = "ProVideoApartamentos";
    AttachmentType[AttachmentType["AerialVideo"] = 55] = "AerialVideo";
    AttachmentType[AttachmentType["ResidentialListingVideo"] = 79] = "ResidentialListingVideo";
})(AttachmentType || (AttachmentType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["ApartmentCommunity"] = 1] = "ApartmentCommunity";
    ListingType[ListingType["ApartmentUnitForRent"] = 2] = "ApartmentUnitForRent";
    ListingType[ListingType["SingleFamilyHome"] = 3] = "SingleFamilyHome";
    /** @deprecated This value has been re-purposed for 'ResidentialCommunity'. */
    ListingType[ListingType["RoomForRent"] = 4] = "RoomForRent";
    ListingType[ListingType["ResidentialCommunity"] = 4] = "ResidentialCommunity";
    ListingType[ListingType["Townhome"] = 5] = "Townhome";
    ListingType[ListingType["CondoUnitForRent"] = 6] = "CondoUnitForRent";
    ListingType[ListingType["ResidentialCondoUnitForRent"] = 7] = "ResidentialCondoUnitForRent";
    ListingType[ListingType["Hospitality"] = 8] = "Hospitality";
})(ListingType || (ListingType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.LaundryType */
export var LaundryType;
(function (LaundryType) {
    LaundryType[LaundryType["None"] = 0] = "None";
    LaundryType[LaundryType["WasherDryer"] = 1] = "WasherDryer";
    LaundryType[LaundryType["WasherDryerHookup"] = 2] = "WasherDryerHookup";
    LaundryType[LaundryType["LaundryFacilities"] = 3] = "LaundryFacilities";
})(LaundryType || (LaundryType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AddListingPets */
export var AddListingPets;
(function (AddListingPets) {
    AddListingPets[AddListingPets["None"] = 0] = "None";
    AddListingPets[AddListingPets["NoneAllowed"] = 1] = "NoneAllowed";
    AddListingPets[AddListingPets["Dog"] = 2] = "Dog";
    AddListingPets[AddListingPets["Cat"] = 4] = "Cat";
})(AddListingPets || (AddListingPets = {}));
import { ParkingType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ParkingType */
export { ParkingType };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AddListingAmenities */
export var AddListingAmenities;
(function (AddListingAmenities) {
    AddListingAmenities[AddListingAmenities["None"] = 0] = "None";
    AddListingAmenities[AddListingAmenities["Furnished"] = 1] = "Furnished";
    AddListingAmenities[AddListingAmenities["SmokeFree"] = 2] = "SmokeFree";
    AddListingAmenities[AddListingAmenities["WheelchairAccessible"] = 4] = "WheelchairAccessible";
})(AddListingAmenities || (AddListingAmenities = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AddListingStatusResponse */
export var AddListingStatusResponse;
(function (AddListingStatusResponse) {
    AddListingStatusResponse[AddListingStatusResponse["None"] = 0] = "None";
    AddListingStatusResponse[AddListingStatusResponse["Active"] = 1] = "Active";
    AddListingStatusResponse[AddListingStatusResponse["Pending"] = 2] = "Pending";
    AddListingStatusResponse[AddListingStatusResponse["OffMarket"] = 3] = "OffMarket";
    AddListingStatusResponse[AddListingStatusResponse["Terminate"] = 4] = "Terminate";
    AddListingStatusResponse[AddListingStatusResponse["Unpublished"] = 6] = "Unpublished";
    AddListingStatusResponse[AddListingStatusResponse["AwaitingVerification"] = 7] = "AwaitingVerification";
    AddListingStatusResponse[AddListingStatusResponse["UserDeleted"] = 8] = "UserDeleted";
})(AddListingStatusResponse || (AddListingStatusResponse = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AddListingContactPreference */
export var AddListingContactPreference;
(function (AddListingContactPreference) {
    AddListingContactPreference[AddListingContactPreference["None"] = 0] = "None";
    AddListingContactPreference[AddListingContactPreference["Phone"] = 1] = "Phone";
    AddListingContactPreference[AddListingContactPreference["Email"] = 2] = "Email";
})(AddListingContactPreference || (AddListingContactPreference = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.MessageType */
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["None"] = 0] = "None";
    MessageType[MessageType["Good"] = 1] = "Good";
    MessageType[MessageType["Warning"] = 2] = "Warning";
})(MessageType || (MessageType = {}));
import { DynamicLeadFormType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.DynamicLeadFormType */
export { DynamicLeadFormType };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ForRentSignType */
export var ForRentSignType;
(function (ForRentSignType) {
    ForRentSignType[ForRentSignType["None"] = 0] = "None";
    ForRentSignType[ForRentSignType["YardSign"] = 1] = "YardSign";
    ForRentSignType[ForRentSignType["WindowSign"] = 2] = "WindowSign";
    ForRentSignType[ForRentSignType["FenceSign"] = 3] = "FenceSign";
    ForRentSignType[ForRentSignType["OpenMarket"] = 3] = "OpenMarket";
})(ForRentSignType || (ForRentSignType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.CleanseAddressStatus */
export var CleanseAddressStatus;
(function (CleanseAddressStatus) {
    CleanseAddressStatus[CleanseAddressStatus["Unknown"] = 0] = "Unknown";
    CleanseAddressStatus[CleanseAddressStatus["Success"] = 1] = "Success";
    CleanseAddressStatus[CleanseAddressStatus["InvalidCityStatePostcode"] = 2] = "InvalidCityStatePostcode";
    CleanseAddressStatus[CleanseAddressStatus["InvalidOrPartialAddress"] = 3] = "InvalidOrPartialAddress";
})(CleanseAddressStatus || (CleanseAddressStatus = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.PointOfInterestDetailType */
export var PointOfInterestDetailType;
(function (PointOfInterestDetailType) {
    PointOfInterestDetailType[PointOfInterestDetailType["None"] = 0] = "None";
    PointOfInterestDetailType[PointOfInterestDetailType["Airport"] = 1] = "Airport";
    PointOfInterestDetailType[PointOfInterestDetailType["CommuterRailStation"] = 2] = "CommuterRailStation";
    PointOfInterestDetailType[PointOfInterestDetailType["TransitStation"] = 3] = "TransitStation";
    PointOfInterestDetailType[PointOfInterestDetailType["College"] = 4] = "College";
    PointOfInterestDetailType[PointOfInterestDetailType["MilitaryBase"] = 5] = "MilitaryBase";
    PointOfInterestDetailType[PointOfInterestDetailType["Park"] = 6] = "Park";
    PointOfInterestDetailType[PointOfInterestDetailType["ShoppingCenter"] = 7] = "ShoppingCenter";
    PointOfInterestDetailType[PointOfInterestDetailType["Railroad"] = 8] = "Railroad";
    PointOfInterestDetailType[PointOfInterestDetailType["Seaport"] = 9] = "Seaport";
})(PointOfInterestDetailType || (PointOfInterestDetailType = {}));
import { ListingAdLevel } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ListingAdLevel */
export { ListingAdLevel };
import { RentPricingType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.RentPricingType */
export { RentPricingType };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AmenityGroupType */
export var AmenityGroupType;
(function (AmenityGroupType) {
    AmenityGroupType[AmenityGroupType["None"] = 0] = "None";
    AmenityGroupType[AmenityGroupType["SpecialFeatures"] = 1] = "SpecialFeatures";
    AmenityGroupType[AmenityGroupType["CommunityFeatures"] = 2] = "CommunityFeatures";
    AmenityGroupType[AmenityGroupType["FloorPlanAmenities"] = 3] = "FloorPlanAmenities";
})(AmenityGroupType || (AmenityGroupType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.TransitStopType */
export var TransitStopType;
(function (TransitStopType) {
    TransitStopType[TransitStopType["Unknown"] = 0] = "Unknown";
    TransitStopType[TransitStopType["Subway"] = 1] = "Subway";
    TransitStopType[TransitStopType["Airport"] = 2] = "Airport";
    TransitStopType[TransitStopType["CommuterRail"] = 3] = "CommuterRail";
})(TransitStopType || (TransitStopType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AvailabilityMatchType */
export var AvailabilityMatchType;
(function (AvailabilityMatchType) {
    AvailabilityMatchType[AvailabilityMatchType["NoMatch"] = 0] = "NoMatch";
    AvailabilityMatchType[AvailabilityMatchType["Perfect"] = 1] = "Perfect";
    AvailabilityMatchType[AvailabilityMatchType["Other"] = 2] = "Other";
    AvailabilityMatchType[AvailabilityMatchType["BudgetStretch"] = 3] = "BudgetStretch";
})(AvailabilityMatchType || (AvailabilityMatchType = {}));
import { CollegeAssignmentType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.CollegeAssignmentType */
export { CollegeAssignmentType };
import { SchoolType } from "../../../../../CoStar/Api/AptsContentSub/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.SchoolType */
export { SchoolType };
import { PetType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.PetType */
export { PetType };
import { PetRequirements } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.PetRequirements */
export { PetRequirements };
import { PetTolerance } from "../../../../../CoStar/Api/EnterpriseSub2/Detail/ResidentialForRent/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.PetTolerance */
export { PetTolerance };
import { ProsumerLevel } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ProsumerLevel */
export { ProsumerLevel };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.DetailUIFlags */
export var DetailUIFlags;
(function (DetailUIFlags) {
    DetailUIFlags[DetailUIFlags["None"] = 0] = "None";
    DetailUIFlags[DetailUIFlags["ShowScams"] = 1] = "ShowScams";
})(DetailUIFlags || (DetailUIFlags = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ListingStatus */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["Unknown"] = 0] = "Unknown";
    ListingStatus[ListingStatus["Active"] = 1] = "Active";
    ListingStatus[ListingStatus["Pending"] = 2] = "Pending";
    ListingStatus[ListingStatus["OffMarket"] = 3] = "OffMarket";
    ListingStatus[ListingStatus["Terminate"] = 4] = "Terminate";
    ListingStatus[ListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatus[ListingStatus["Unpublished"] = 6] = "Unpublished";
    ListingStatus[ListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatus[ListingStatus["UserDeleted"] = 8] = "UserDeleted";
})(ListingStatus || (ListingStatus = {}));
import { ApartmentStyleType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ApartmentStyleType */
export { ApartmentStyleType };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.RentDeals */
export var RentDeals;
(function (RentDeals) {
    RentDeals[RentDeals["None"] = 0] = "None";
    RentDeals[RentDeals["RentSpecial"] = 1] = "RentSpecial";
    RentDeals[RentDeals["BestValue"] = 2] = "BestValue";
    RentDeals[RentDeals["TopDeal"] = 4] = "TopDeal";
})(RentDeals || (RentDeals = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.RentPricingTypes */
export var RentPricingTypes;
(function (RentPricingTypes) {
    RentPricingTypes[RentPricingTypes["None"] = 0] = "None";
    RentPricingTypes[RentPricingTypes["PerUnit"] = 1] = "PerUnit";
    RentPricingTypes[RentPricingTypes["PerBed"] = 2] = "PerBed";
    RentPricingTypes[RentPricingTypes["PerBedroom"] = 4] = "PerBedroom";
})(RentPricingTypes || (RentPricingTypes = {}));
import { CostMultiplierType } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.CostMultiplierType */
export { CostMultiplierType };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ListingPinOptions */
export var ListingPinOptions;
(function (ListingPinOptions) {
    ListingPinOptions[ListingPinOptions["None"] = 0] = "None";
    ListingPinOptions[ListingPinOptions["HasVideo"] = 1] = "HasVideo";
    ListingPinOptions[ListingPinOptions["IsTier2"] = 2] = "IsTier2";
    ListingPinOptions[ListingPinOptions["IsNew"] = 4] = "IsNew";
})(ListingPinOptions || (ListingPinOptions = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.GeographyType */
export var GeographyType;
(function (GeographyType) {
    GeographyType[GeographyType["Unknown"] = 0] = "Unknown";
    GeographyType[GeographyType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyType[GeographyType["Airport"] = 22] = "Airport";
    GeographyType[GeographyType["TransitStation"] = 24] = "TransitStation";
    GeographyType[GeographyType["Military"] = 25] = "Military";
    GeographyType[GeographyType["University"] = 26] = "University";
    GeographyType[GeographyType["ParkAndRecreation"] = 33] = "ParkAndRecreation";
})(GeographyType || (GeographyType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.PointOfInterestGroups */
export var PointOfInterestGroups;
(function (PointOfInterestGroups) {
    PointOfInterestGroups[PointOfInterestGroups["None"] = 0] = "None";
    PointOfInterestGroups[PointOfInterestGroups["Bank"] = 1] = "Bank";
    PointOfInterestGroups[PointOfInterestGroups["Bar"] = 2] = "Bar";
    PointOfInterestGroups[PointOfInterestGroups["Coffee"] = 3] = "Coffee";
    PointOfInterestGroups[PointOfInterestGroups["Fitness"] = 4] = "Fitness";
    PointOfInterestGroups[PointOfInterestGroups["Grocery"] = 5] = "Grocery";
    PointOfInterestGroups[PointOfInterestGroups["Restaurant"] = 6] = "Restaurant";
    PointOfInterestGroups[PointOfInterestGroups["Shop"] = 7] = "Shop";
})(PointOfInterestGroups || (PointOfInterestGroups = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ReviewNotificationSettings */
export var ReviewNotificationSettings;
(function (ReviewNotificationSettings) {
    ReviewNotificationSettings[ReviewNotificationSettings["None"] = 0] = "None";
    ReviewNotificationSettings[ReviewNotificationSettings["OnSubmission"] = 1] = "OnSubmission";
    ReviewNotificationSettings[ReviewNotificationSettings["OnComment"] = 2] = "OnComment";
})(ReviewNotificationSettings || (ReviewNotificationSettings = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.MultifamilyMatchType */
export var MultifamilyMatchType;
(function (MultifamilyMatchType) {
    MultifamilyMatchType[MultifamilyMatchType["Unknown"] = 0] = "Unknown";
    MultifamilyMatchType[MultifamilyMatchType["Property"] = 1] = "Property";
    MultifamilyMatchType[MultifamilyMatchType["PostalCode"] = 2] = "PostalCode";
    MultifamilyMatchType[MultifamilyMatchType["City"] = 3] = "City";
    MultifamilyMatchType[MultifamilyMatchType["BuildingName"] = 4] = "BuildingName";
    MultifamilyMatchType[MultifamilyMatchType["Submarket"] = 5] = "Submarket";
    MultifamilyMatchType[MultifamilyMatchType["Street"] = 6] = "Street";
    MultifamilyMatchType[MultifamilyMatchType["ResearchMarket"] = 7] = "ResearchMarket";
    MultifamilyMatchType[MultifamilyMatchType["Contact"] = 8] = "Contact";
    MultifamilyMatchType[MultifamilyMatchType["Company"] = 9] = "Company";
    MultifamilyMatchType[MultifamilyMatchType["County"] = 10] = "County";
    MultifamilyMatchType[MultifamilyMatchType["Subdivision"] = 11] = "Subdivision";
    MultifamilyMatchType[MultifamilyMatchType["GeocodeResult"] = 12] = "GeocodeResult";
    MultifamilyMatchType[MultifamilyMatchType["BuildingPark"] = 13] = "BuildingPark";
    MultifamilyMatchType[MultifamilyMatchType["ShoppingCenter"] = 14] = "ShoppingCenter";
    MultifamilyMatchType[MultifamilyMatchType["Country"] = 15] = "Country";
    MultifamilyMatchType[MultifamilyMatchType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    MultifamilyMatchType[MultifamilyMatchType["Region"] = 17] = "Region";
    MultifamilyMatchType[MultifamilyMatchType["StoreType"] = 18] = "StoreType";
    MultifamilyMatchType[MultifamilyMatchType["PropertyResidential"] = 20] = "PropertyResidential";
    MultifamilyMatchType[MultifamilyMatchType["Cluster"] = 21] = "Cluster";
    MultifamilyMatchType[MultifamilyMatchType["Airport"] = 22] = "Airport";
    MultifamilyMatchType[MultifamilyMatchType["HotelName"] = 23] = "HotelName";
    MultifamilyMatchType[MultifamilyMatchType["TransitStation"] = 24] = "TransitStation";
    MultifamilyMatchType[MultifamilyMatchType["Military"] = 25] = "Military";
    MultifamilyMatchType[MultifamilyMatchType["University"] = 26] = "University";
    MultifamilyMatchType[MultifamilyMatchType["StoreBrand"] = 27] = "StoreBrand";
    MultifamilyMatchType[MultifamilyMatchType["GoogleResults"] = 28] = "GoogleResults";
    MultifamilyMatchType[MultifamilyMatchType["PropertyManagers"] = 29] = "PropertyManagers";
    MultifamilyMatchType[MultifamilyMatchType["SearchEngineOptimization"] = 30] = "SearchEngineOptimization";
    MultifamilyMatchType[MultifamilyMatchType["MultifamilyProperty"] = 41] = "MultifamilyProperty";
})(MultifamilyMatchType || (MultifamilyMatchType = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.TypeAheadUse */
export var TypeAheadUse;
(function (TypeAheadUse) {
    TypeAheadUse[TypeAheadUse["Unknown"] = 0] = "Unknown";
    TypeAheadUse[TypeAheadUse["Search"] = 1] = "Search";
    TypeAheadUse[TypeAheadUse["AddListing"] = 2] = "AddListing";
})(TypeAheadUse || (TypeAheadUse = {}));
import { MoveInTimeframe } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.MoveInTimeframe */
export { MoveInTimeframe };
import { ContactOption } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ContactOption */
export { ContactOption };
import { MoveReason } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.MoveReason */
export { MoveReason };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ExternalLoginProviders */
export var ExternalLoginProviders;
(function (ExternalLoginProviders) {
    ExternalLoginProviders[ExternalLoginProviders["None"] = 0] = "None";
    ExternalLoginProviders[ExternalLoginProviders["Google"] = 1] = "Google";
    ExternalLoginProviders[ExternalLoginProviders["Facebook"] = 2] = "Facebook";
})(ExternalLoginProviders || (ExternalLoginProviders = {}));
import { NotificationFrequency } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/RegisterUser/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.NotificationFrequency */
export { NotificationFrequency };
import { NotificationSubscriptions } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/RegisterUser/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.NotificationSubscriptions */
export { NotificationSubscriptions };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.UserProperties */
export var UserProperties;
(function (UserProperties) {
    UserProperties[UserProperties["None"] = 0] = "None";
    UserProperties[UserProperties["IsProsumer"] = 1] = "IsProsumer";
})(UserProperties || (UserProperties = {}));
import { UserNotificationMediums } from "../../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/RegisterUser/index.js";
/** CoStar.Api.AptsNet.MobileServices.ViewModels.UserNotificationMediums */
export { UserNotificationMediums };
/** CoStar.Api.AptsNet.MobileServices.ViewModels.ExternalLoginProvider */
export var ExternalLoginProvider;
(function (ExternalLoginProvider) {
    ExternalLoginProvider[ExternalLoginProvider["Unknown"] = 0] = "Unknown";
    ExternalLoginProvider[ExternalLoginProvider["Google"] = 1] = "Google";
    ExternalLoginProvider[ExternalLoginProvider["Facebook"] = 2] = "Facebook";
})(ExternalLoginProvider || (ExternalLoginProvider = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.AuthError */
export var AuthError;
(function (AuthError) {
    AuthError[AuthError["None"] = 0] = "None";
    AuthError[AuthError["InvalidAccessToken"] = 1] = "InvalidAccessToken";
    AuthError[AuthError["PasswordComplexityCheckFailed"] = 2] = "PasswordComplexityCheckFailed";
    AuthError[AuthError["EmailExisted"] = 3] = "EmailExisted";
    AuthError[AuthError["FailedToCreateApartmentNetworkAccount"] = 4] = "FailedToCreateApartmentNetworkAccount";
    AuthError[AuthError["FailedAddingClaimToUser"] = 5] = "FailedAddingClaimToUser";
    AuthError[AuthError["UserNameRequired"] = 6] = "UserNameRequired";
    AuthError[AuthError["PasswordRequired"] = 7] = "PasswordRequired";
    AuthError[AuthError["ProviderRequired"] = 8] = "ProviderRequired";
    AuthError[AuthError["ProviderAccessTokenRequired"] = 9] = "ProviderAccessTokenRequired";
    AuthError[AuthError["InvalidProviderAccessToken"] = 10] = "InvalidProviderAccessToken";
    AuthError[AuthError["InvalidUserNamePassword"] = 11] = "InvalidUserNamePassword";
    AuthError[AuthError["NoProviderAccessTokenUser"] = 12] = "NoProviderAccessTokenUser";
    AuthError[AuthError["NotEnoughInfoToAuthenticate"] = 13] = "NotEnoughInfoToAuthenticate";
    AuthError[AuthError["UserLockedOut"] = 14] = "UserLockedOut";
    AuthError[AuthError["MismatchError"] = 15] = "MismatchError";
    AuthError[AuthError["InactiveUser"] = 16] = "InactiveUser";
    AuthError[AuthError["FailedToCreateAccountAuth"] = 17] = "FailedToCreateAccountAuth";
    AuthError[AuthError["FailedToLogUserInAfterRegistration"] = 18] = "FailedToLogUserInAfterRegistration";
    AuthError[AuthError["UnknownError"] = 100] = "UnknownError";
})(AuthError || (AuthError = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.FavoriteListingSyncAction */
export var FavoriteListingSyncAction;
(function (FavoriteListingSyncAction) {
    FavoriteListingSyncAction[FavoriteListingSyncAction["Add"] = 0] = "Add";
    FavoriteListingSyncAction[FavoriteListingSyncAction["Remove"] = 1] = "Remove";
})(FavoriteListingSyncAction || (FavoriteListingSyncAction = {}));
/** CoStar.Api.AptsNet.MobileServices.ViewModels.HiddenListingSyncAction */
export var HiddenListingSyncAction;
(function (HiddenListingSyncAction) {
    HiddenListingSyncAction[HiddenListingSyncAction["Add"] = 0] = "Add";
    HiddenListingSyncAction[HiddenListingSyncAction["Remove"] = 1] = "Remove";
})(HiddenListingSyncAction || (HiddenListingSyncAction = {}));
export { Criteria, Renters, VerifyIdentity };
